import React, { useState, useEffect } from 'react';
import { useLanguage } from '../i18n';
import { getCachedTranslation, requestTranslation } from '../i18n/translationCache';

/**
 * Componente per tradurre testo dinamico usando Gemini
 * Con cache persistente in localStorage per velocità
 */
const TranslatedText = ({ 
  text, 
  as: Component = 'span', 
  className = '',
  ...props 
}) => {
  const { language } = useLanguage();
  const [translatedText, setTranslatedText] = useState(() => {
    // Prova prima la cache
    if (language === 'it' || !text) return text;
    return getCachedTranslation(text, language) || text;
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Se italiano o testo vuoto, mostra originale
    if (!text || language === 'it') {
      setTranslatedText(text);
      return;
    }

    // Controlla cache
    const cached = getCachedTranslation(text, language);
    if (cached) {
      setTranslatedText(cached);
      return;
    }

    // Richiedi traduzione (con batching automatico)
    setIsLoading(true);
    requestTranslation(text, language, (translation) => {
      setTranslatedText(translation);
      setIsLoading(false);
    });
  }, [text, language]);

  return (
    <Component className={`${className} ${isLoading ? 'opacity-70' : ''}`} {...props}>
      {translatedText}
    </Component>
  );
};

export default TranslatedText;
